import { FeeDetailDto } from "interfaces";

export type FeeRow = {
  key: string;
  label: string;
  percent: number;
  rub?: number;
  isTotal?: boolean;
};

type BuildFeeRowsParams = {
  feeDetail: FeeDetailDto;
  amountRub: number | undefined;
  showRub: boolean;
  showAmountDiscount: boolean;
  totalFee: number;
  totalFeeRub: number | undefined;
};

const multiplyRub = (amountRub: number | undefined, share: number): number | undefined =>
  amountRub === undefined || amountRub === null ? undefined : amountRub * share;

export const buildFeeRows = ({
  feeDetail,
  amountRub,
  showRub,
  showAmountDiscount,
  totalFee,
  totalFeeRub,
}: BuildFeeRowsParams): FeeRow[] => {
  const { baseFee, acquiringFee, acquiringFeeRub, agentFee, additionalRequestsFee, amountDiscount, customFee } =
    feeDetail;

  const rows: FeeRow[] = [];

  rows.push({
    key: "baseFee",
    label: "Основная ставка",
    percent: baseFee,
    rub: showRub ? multiplyRub(amountRub, baseFee) : undefined,
  });

  if (acquiringFee !== 0) {
    rows.push({
      key: "acquiringFee",
      label: "Эквайринг*",
      percent: acquiringFee,
      rub: showRub ? acquiringFeeRub : undefined,
    });
  }

  if (agentFee !== 0) {
    rows.push({
      key: "agentFee",
      label: "За платёжного агента",
      percent: agentFee,
      rub: showRub ? multiplyRub(amountRub, agentFee) : undefined,
    });
  }

  if (additionalRequestsFee !== 0) {
    rows.push({
      key: "additionalRequestsFee",
      label: "За доп. заявки",
      percent: additionalRequestsFee,
      rub: showRub ? multiplyRub(amountRub, additionalRequestsFee) : undefined,
    });
  }

  if (showAmountDiscount && amountDiscount !== 0) {
    rows.push({
      key: "amountDiscount",
      label: "Скидка за сумму",
      percent: -amountDiscount,
      rub: showRub ? multiplyRub(amountRub, -amountDiscount) : undefined,
    });
  }

  if (customFee > 0) {
    rows.push({
      key: "customFeePositive",
      label: "Дополнительная комиссия",
      percent: customFee,
      rub: showRub ? multiplyRub(amountRub, customFee) : undefined,
    });
  } else if (customFee < 0) {
    rows.push({
      key: "customFeeNegative",
      label: "Дополнительная скидка",
      percent: customFee,
      rub: showRub ? multiplyRub(amountRub, customFee) : undefined,
    });
  }

  rows.push({
    key: "total",
    label: "Итого",
    percent: totalFee,
    rub: showRub ? totalFeeRub : undefined,
    isTotal: true,
  });

  return rows;
};
